export const API_BASE_URL = import.meta.env.VITE_API_GATEWAY_BASE_URL;

export const TERMINOLOGY = `http://terminology.hl7.org/`;
export const URL_PREFIX = '/emr/fhir/R4';
export const FHIR_API = `${API_BASE_URL}${URL_PREFIX}`;

// Login api endpoints
export const REFRESH_TOKEN_ENDPOINT = `${URL_PREFIX}/token/refresh/`;
export const LOGIN_ENDPOINT = `${URL_PREFIX}/login/`;
export const SIGNUP_ENDPOINT = `${URL_PREFIX}/signup/`;

export const QUESTIONNAIRE_LIST = URL_PREFIX;

export const REST_URL_PREFIX = '/auth-service/v2';

export const USERS = `${REST_URL_PREFIX}/users`;

export const IMAGE_UPLOAD = `${URL_PREFIX}/Binary`;
export const CODE_SYSTEM = `${TERMINOLOGY}/CodeSystem`;

export const LOINC_FHIR_URL = `http://loinc.org`;
